import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { MessageScreen } from "../../common/MessageScreen";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";
import { CardTanSettingsStore } from "./CardTanSettingsStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: CardTanSettingsStore;
}

@inject("externalInterfaceStore")
export class CardTanSettingsActivateGeorgeIdSuccess extends React.Component<RouteComponentProps<{}> & IProps> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                title={ui.__("cardTanSettings.activateGeorgeId.success.title")}
                messageComponent={<i18n.FormattedHTMLMessage id="cardTanSettings.activateGeorgeId.success.message" />}
                buttonLabelId="common.close"
                onDismiss={async () => externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsActivateGeorgeIdSuccess.tsx